import PropTypes from 'prop-types';
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getEreaderProgressRatio } from 'a/hub/selectors/';
import { useFirstUserInteraction } from 'lib/hooks';
import { advanceToNextWorkshopStep } from 'root/activities/hub/actions/workshopActions';
import { BookIcon, BaseSuccessModal } from '../sharedComponents';

const EReaderSuccessModal = ({ closeModal, config }) => {
  const dispatch = useDispatch();
  const completeRatio = useSelector(getEreaderProgressRatio);
  const {
    heading = 'Ereader Complete!',
    text = "Click the *blueprints* to review everything you've completed!",
  } = config;

  const firstUserInteraction = useFirstUserInteraction();

  const onClick = (e) => {
    const source = 'EReaderSuccessModal';
    dispatch(advanceToNextWorkshopStep(source, true, config.openedAtStep));
    firstUserInteraction(e);
    closeModal();
  };

  return (
    <BaseSuccessModal
      headerText={heading}
      descriptionText={text}
      onConfirm={onClick}
      actionScope="ereader-success-modal"
    >
      <BookIcon top={203} left={335} completeRatio={completeRatio} />
    </BaseSuccessModal>
  );
};

EReaderSuccessModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  config: PropTypes.object.isRequired,
};

export default EReaderSuccessModal;
